document.querySelectorAll('.loyalty-tiers').forEach(function (section) {
  var tabs = section.querySelectorAll('.loyalty-tiers__tab');
  var table = section.querySelector('.loyalty-tiers__table');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      table.dataset.activeTier = tab.dataset.tier;
    });
  });
});
